import axios from 'axios';
import {
  GET_USER_XP,
  GET_XP_HISTORY,
  GET_XP_LEADERBOARD,
  AWARD_XP,
  RESET_USER_XP,
  XP_LOADING
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get current user's XP profile
export const getUserXP = () => (dispatch, getState) => {
  dispatch(setXPLoading());
  
  axios
    .get('/api/experiencepoints/me', tokenConfig(getState))
    .then(res => dispatch({
      type: GET_USER_XP,
      payload: res.data
    }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get user's XP history
export const getXPHistory = (limit = 50) => (dispatch, getState) => {
  dispatch(setXPLoading());
  
  axios
    .get(`/api/experiencepoints/history?limit=${limit}`, tokenConfig(getState))
    .then(res => dispatch({
      type: GET_XP_HISTORY,
      payload: res.data
    }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get XP leaderboard, optionally filtered by program and sort criteria
export const getXPLeaderboard = (limit = 50, programId = null, sortBy = 'xp') => (dispatch, getState) => {
  dispatch(setXPLoading());

  let url = `/api/experiencepoints/leaderboard?limit=${limit}&sortBy=${sortBy}`;
  if (programId) url += `&programId=${programId}`;

  axios
    .get(url, tokenConfig(getState))
    .then(res => dispatch({
      type: GET_XP_LEADERBOARD,
      payload: res.data
    }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Manually award XP (Admin only)
export const awardXP = (xpData) => (dispatch, getState) => {
  axios
    .post('/api/experiencepoints/award', xpData, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: AWARD_XP,
        payload: res.data
      });
      
      // Refresh user XP after awarding
      dispatch(getUserXP());
    })
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Reset current user's XP profile
export const resetUserXP = () => (dispatch, getState) => {
  dispatch(setXPLoading());
  
  axios
    .delete('/api/experiencepoints/reset', tokenConfig(getState))
    .then(res => dispatch({
      type: RESET_USER_XP,
      payload: res.data
    }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Reset specific user's XP profile (Admin only)
export const resetSpecificUserXP = (userId) => (dispatch, getState) => {
  dispatch(setXPLoading());
  
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/experiencepoints/reset/${userId}`, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: RESET_USER_XP,
          payload: res.data
        });
        resolve(res.data);
      })
      .catch(err => {
        dispatch(returnErrors(err.response?.data, err.response?.status));
        reject(err);
      });
  });
};

// Set loading state
export const setXPLoading = () => {
  return { type: XP_LOADING };
};